import { guardedFetch, authenticatedFetch } from "./utils";
import type { ApiResponse } from "../../types/api";
import API_CONSTANTS from "../constants/api";
import type { PersistedAddress } from "./address";

export async function validateIdentifier(identifier: string, jwt: string): Promise<ApiResponse> {
  const url = `${API_CONSTANTS.frontendBaseUrl}/v1/user/validate-identifier?identifier=${identifier}`;

  const result = await guardedFetch(url, {
    method: "get",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${jwt}`
    }
  });
  return (await result.json()) as ApiResponse;
}

type UserMetaData = {
  email_verified: string;
};

export type UserData = {
  first_name: string;
  last_name: string;
  email: string;
  phone: string;
  metadata?: UserMetaData | null;
  addresses: PersistedAddress[];
};

export type UserDataInput = {
  first_name: string,
  last_name: string,
  email: string,
  phone?: string,
  entryToken?: string;
} & Record<string, unknown>;

type UserResponse = ApiResponse & { me?: UserData };

export const getUser = async (): Promise<UserData | undefined> => {
  const url = `${API_CONSTANTS.authApiBaseUrl}/me`;
  const result = await authenticatedFetch(url);
  return ((await result.json()) as UserResponse).me;
};

export const updateUser = async (userData: UserDataInput): Promise<ApiResponse> => {
  const url = `${API_CONSTANTS.authApiBaseUrl}/me`;
  const result = await authenticatedFetch(url, {
    method: "PUT",
    body: JSON.stringify(userData)
  });

  return (await result.json()) as ApiResponse;
};

export const updateUserMetadata = async (metadata: Record<string, unknown>): Promise<void> => {
  const url = `${API_CONSTANTS.authApiBaseUrl}/me`;
  await authenticatedFetch(url, {
    method: "PUT",
    body: JSON.stringify(metadata)
  });
};

export const saveUserSettings = async (settings: Record<string, unknown>): Promise<ApiResponse> => {
  const url = `${API_CONSTANTS.frontendBaseUrl}/v1/user/settings`;
  const result = await authenticatedFetch(url, {
    method: "POST",
    body: JSON.stringify({ settings })
  });

  return (await result.json()) as ApiResponse;
};

export const validateEntry = async (entryGateData: Record<string, string | number>): Promise<ApiResponse> => {
  const url = `${API_CONSTANTS.frontendBaseUrl}/v1/user/validate-entry`;
  const result = await authenticatedFetch(url, {
    method: "POST",
    body: JSON.stringify(entryGateData)
  });

  return (await result.json()) as ApiResponse;
};
